import semver from 'semver'
import { z } from 'zod'

export type DappInfo = {
  version: string
  downloadUrls: {
    win32x64: string
    darwinarm64: string
    darwinx64: string
  }
}
export type DappVersionDiff = 'patch' | 'minor' | 'major' | 'none'

export const getDappVersionDiff = ({ userVersion, latestVersion }: { userVersion: string; latestVersion: string }) => {
  const isLatestMajorBigger = semver.major(latestVersion) > semver.major(userVersion)
  const isLatestMinorBigger = semver.minor(latestVersion) > semver.minor(userVersion)
  const isLatestPatchBigger = semver.patch(latestVersion) > semver.patch(userVersion)
  const diffType: DappVersionDiff = (() => {
    if (isLatestMajorBigger) {
      return 'major'
    }
    if (isLatestMinorBigger) {
      return 'minor'
    }
    if (isLatestPatchBigger) {
      return 'patch'
    }
    return 'none'
  })()
  const updateRequired = diffType === 'major' || diffType === 'minor'
  // const updateRequired = diffType === 'major' || diffType === 'minor' || diffType === 'patch'
  const updatePossible = diffType !== 'none'
  return {
    diffType,
    updateRequired,
    updatePossible,
  }
}

export const zDappVersion = z.string().regex(/^\d+\.\d+\.\d+$/, 'Версия должна быть в формате X.Y.Z')
